import { useState } from "react";
import { ChannelChip, SalesTypeBadge, VoidBadge } from "@/components/common/Chips";
import { EmptyState, Loading } from "@/components/common/ui";
import { inputCls } from "@/components/common/Field";
import { RegisterArt } from "@/components/bakery/Art";
import { useApi } from "@/lib/useApi";
import { CHANNELS, fmtDate, saleUnitLabel, shiftDate, todayJkt } from "@/lib/format";
import { cn } from "@/lib/utils";

export default function SalesHistory({ onOpen, reloadKey }) {
  const [from, setFrom] = useState(shiftDate(todayJkt(), -6));
  const [to, setTo] = useState(todayJkt());
  const [channel, setChannel] = useState("");
  const { data, loading } = useApi("/transactions", { type: "SLS", date_from: from, date_to: to, rk: reloadKey });
  const list = (data || []).filter((t) => !channel || t.channel === channel);
  return (
    <div>
      <div className="mb-6 flex flex-col gap-3 sm:flex-row">
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={cn(inputCls, "sm:w-48")} data-testid="sales-filter-from" />
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className={cn(inputCls, "sm:w-48")} data-testid="sales-filter-to" />
        <select value={channel} onChange={(e) => setChannel(e.target.value)} className={cn(inputCls, "sm:w-56")} data-testid="sales-filter-channel">
          <option value="">Semua channel</option>{CHANNELS.map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>
      {loading && !data ? <Loading /> : list.length ? (
        <div className="grid gap-x-5 gap-y-8 sm:grid-cols-2 xl:grid-cols-3" data-testid="sales-history-list">
          {list.map((t) => (
            <button key={t.id} onClick={() => onOpen(t.id)} data-testid={`sales-receipt-${t.txn_no}`}
              className={cn("receipt lift mt-2 px-4 py-5 text-left", t.status === "void" && "opacity-60")}>
              <div className="flex items-center justify-between gap-2">
                <span className="num text-xs font-bold">{t.txn_no}</span><VoidBadge txn={t} /><span className="text-[11px] text-zinc-500">{fmtDate(t.date)}</span>
              </div>
              <div className="mt-2 flex flex-wrap gap-1.5"><ChannelChip channel={t.channel} /><SalesTypeBadge type={t.sales_type} />
                {t.source === "import" && <span className="text-[11px] text-zinc-500">{t.order_count} order · import</span>}</div>
              {t.customer && <div className="mt-1 text-xs text-zinc-600">untuk {t.customer}</div>}
              <div className="my-3 border-t border-dashed border-zinc-300" />
              <ul className="space-y-1 text-xs">
                {t.lines.slice(0, 6).map((l, i) => (
                  <li key={i} className="flex justify-between gap-2"><span className="truncate">{l.product_name}</span><span className="num shrink-0">{l.qty} {saleUnitLabel(l).split(" ")[0]}</span></li>
                ))}
                {t.lines.length > 6 && <li className="text-zinc-400">+{t.lines.length - 6} produk lain</li>}
              </ul>
              <div className="my-3 border-t border-dashed border-zinc-300" />
              <div className="flex justify-between text-sm font-bold"><span>Total</span><span className="num">{t.lines.reduce((s, l) => s + l.qty, 0)}</span></div>
            </button>
          ))}
        </div>
      ) : <EmptyState Art={RegisterArt} title="Belum ada struk" desc="Tidak ada penjualan di periode ini." testid="sales-empty" />}
    </div>
  );
}
